import Api from "../../axios"

export const getViewManualMessage= async(id)=>{
    return await Api.get(`/view_message_attendance?application_id=${id}`)
}